import { IonContent, IonInput, IonPage, IonText, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Head from "../Header"
import Select from 'react-select';
import Sidebar from "../Sidebar"
import swal from 'sweetalert';
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const ActivityReportingRelation: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [id] = useState(localStorage.getItem("SignupEmpId"))

    const [reportingPerson, setReportingPerson]: any = useState([]);
    const [reportingPerson2, setReportingPerson2]: any = useState([]);

    const [canceled, setCanceled] = useState(false);
   
   // const [menuIsOpen1, setMenuIsOpen1] = useState(false);
    const [employeelist, setEmployeelist] = useState([]);
    const [data, setData] = useState([])
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(null);
    const [filterText, setFilterText] = useState("");
   
    const [isFocused2, setIsFocused2] = useState(false);
 
    // ------------------------------Transfer employees-----------------------------------
    const [reporttoid, setreporttoid] = useState('')
    const [employeeschecked, setemployeeschecked] = useState([])
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [isCheckboxSelected, setIsCheckboxSelected] = useState(false);
    const [isFromManagerSelected, setIsFromManagerSelected] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // const [isContentVisible, setIsContentVisible] = useState(true);
    useEffect(() => {
        LoadEmployeeList();
    }, []);

/*................... Reporting(From) Auto complete .................. */

const [selectedOption, setSelectedOption] = useState(null);
const [inputValue, setInputValue] = useState('');
const [isFocused, setIsFocused] = useState(false);
const [menuIsOpen, setMenuIsOpen] = useState(false);

const handleStateChange = (selectedOption: any) => {
   setSelectedOption(selectedOption);
};

const handleInputChange = (inputValue: any) => {
   setInputValue(inputValue);
};

const handleMenuOpen = () => {
   setMenuIsOpen(true);
};

const handleMenuClose = () => {
   setMenuIsOpen(false);
};

const handleFocus = () => {
   setIsFocused(true);
};

const handleBlur = () => {
   setIsFocused(false);
};

const Placeholder = () => {
   if (inputValue === '' && !selectedOption && !isFocused) {
       return <span style={{ color: "black" }}>Select Reporting Manager </span>;
   } else {
       return <span style={{ color: "black" }}>Type to Search Here...</span>;
   }
};
const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
   const [isClicked, setIsClicked] = useState(false);

   useEffect(() => {
       if (isClicked && !selectProps.menuIsOpen) {
           setIsClicked(false);
       }
   }, [selectProps.menuIsOpen]);

   let icon
   if (isClicked || selectProps.menuIsOpen) {
       icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
   } else {
       icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
   }

   const handleIconClick = () => {
       setIsClicked(true);
   };

   return (
       <div {...innerProps}>
           <div onClick={handleIconClick}>{icon}</div>
       </div>
   );
};
   const option1 = [
       ...employeelist.map((state: any) => ({
           value: state.id,
           label: state.name,
       })),
   ];

   const handleManagerChange = (selectedOption: any) => {
       setReportingPerson(selectedOption.value);
       setSelectedEmployeeId(selectedOption.value);
       EmployeesByManager(selectedOption.value);
       setIsFromManagerSelected(true);
   };

 /*................... Reporting(To) Auto complete .................. */

 const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

 const handleStateChange1 = (selectedOption1: any) => {
    setSelectedOption1(selectedOption1);
};

const handleInputChange1 = (inputValue1: any) => {
    setInputValue1(inputValue1);
};

const handleMenuOpen1 = () => {
    setMenuIsOpen1(true);
};

const handleMenuClose1 = () => {
    setMenuIsOpen1(false);
};

const handleFocus1 = () => {
    setIsFocused1(true);
};

const handleBlur1 = () => {
    setIsFocused1(false);
};
const Placeholder1 = () => {
    if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
        return <span style={{ color: "black" }}>Select Reporting Manager </span>;
    } else {
        return <span style={{ color: "black" }}>Type to Search Here...</span>;
    }
};
const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
    const [isClicked, setIsClicked] = useState(false);

    useEffect(() => {
        if (isClicked && !selectProps.menuIsOpen) {
            setIsClicked(false);
        }
    }, [selectProps.menuIsOpen]);

    let icon
    if (isClicked || selectProps.menuIsOpen) {
        icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
    } else {
        icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
    }

    const handleIconClick = () => {
        setIsClicked(true);
    };

    return (
        <div {...innerProps}>
            <div onClick={handleIconClick}>{icon}</div>
        </div>
    );
};
    const option2 = [

        ...employeelist.map((state: any) => ({
            value: state.id,
            label: state.name,
        })),

    ];
    const handleManagerChange2 = (selectedOption1: any) => {
        setReportingPerson2(selectedOption1.value);
        setreporttoid(selectedOption1.value);
    };
 
     /*................... Datatable .................. */
    
    const handleRowSelected = (selectedRows: any[]) => {
        setSelectedRows(selectedRows.map(row => row.id));
        setIsCheckboxSelected(selectedRows.length > 0);
    };
    
      /*...................To empty the input .................. */

const load =()=>{
   
        setIsFocused2(true);
        setSelectedRows([]); 
        setReportingPerson(null);
        setReportingPerson2(null);
    };

    // *,,,,,,,,,,,,, get all employe ,,,,,,,,,,,,,*

    const LoadEmployeeList = () => {
     
        service.GetAllEmployeeNameDropDown()
            .then((response) => {
                console.log("All Employee Names")
                console.log(response);
                if (response.data === null || response.data.Data === null) {
                    setEmployeelist([])
                }
                else {
                    setEmployeelist(response.data.Data);
                }
            })
    }

    // *,,,,,,,,,,,,, get all employe by manager,,,,,,,,,,,,,*

    const EmployeesByManager = (id: any) => {
        setIsLoading(true);
        service.GetAllEmployeeByManagers(id)
            .then((response) => {
                console.log("Manager filter my employees");
                console.log(response);
                if (response.status === 200) {
                    setData(response.data);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {
                // This code will execute whether the promise is resolved or rejected
                setTimeout(() => {
                    setIsLoading(false); // Hide loading after a delay (e.g., 1000 milliseconds)
                }, 500); // Adjust the timeout duration as needed
            });
    };
    // -----------------------------TransferEmployees---------------------
    const TransferEmployee = () => {
        setIsLoading(true);
        setTimeout(() => {
            if (!reporttoid) {
                setIsLoading(false);
                swal("", "Please Select Reporting Manager (To)", "info");
            } else if (selectedRows.length === 0) {
                setIsLoading(false); 
                swal("", "Please Select at least one employee to transfer", "info");
            } else {
                service.TransferEmployee(reporttoid, selectedRows)
                    .then((response) => {
                        console.log(response);
    
                        if (response.status === 200) {
                            swal("", response.data, "success").then(() => {
                                setIsLoading(false); 
                                window.location.reload();
                            });
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        setIsLoading(false); 
                        swal("", "An error occurred during the transfer.", "error");
                    });
            }
        }, 1500);
    };
    const datatable = Array.isArray(data)
    ? data.filter((item: any) => JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
    : [];
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);
    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                justifyContent: "center"
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: true,
            width: "100px",
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.name,
            sortable: true,
            sort: "name",
            cell: (itm: any) => (
                <div className="wrapper_cls">
                    {itm.name !== null && itm.name !== ""
                        ? `${itm.name} ${itm.employeeCode !== null ? `(${itm.employeeCode})` : ""}`
                        : "No Name"
                    }
                </div>
            )
                },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            sortable: true,
            sort: "businessUnitName",
            // width: "300px",
            cell: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NULL';
                }
            },
        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.masterDepartment.departmentName,
            sortable: true,
            sort: "departmentName",
            // width: "200px",
            cell: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NULL';
                }
            },
        },
        
        
    ];
    const back = () => {
        history.goBack();
    }
    return (
       
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
           
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />Change Reporting Manager</h3>
                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Reporting Manager (From) <span className="text-danger">*</span></label>
                                        <div>
                                            <Select
                                                options={option1}
                                                value={option1.find((option) => option.value === reportingPerson) || null}
                                                onChange={handleManagerChange}
                                                onInputChange={handleInputChange}
                                                onMenuOpen={handleMenuOpen}
                                                onMenuClose={handleMenuClose}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                menuIsOpen={menuIsOpen}
                                                isSearchable
                                                placeholder={<Placeholder />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator,
                                                }}
                                                className="custom-select0"
                                            />
                                        </div>
                                    </div>
                                </div>
                               
                                <div className="col-sm-6 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Reporting Manager (To) <span className="text-danger">*</span></label>
                                        <div>
                                            <Select
                                                options={option2}
                                                value={option2.find((option) => option.value === reportingPerson2) || null}
                                                onChange={handleManagerChange2}
                                                onInputChange={handleInputChange1}
                                                onMenuOpen={handleMenuOpen1}
                                                onMenuClose={handleMenuClose1}
                                                onFocus={handleFocus1}
                                                onBlur={handleBlur1}
                                                menuIsOpen={menuIsOpen1}
                                                isSearchable
                                                placeholder={<Placeholder1 />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator1,
                                                }}
                                                className="custom-select7"
                                            />
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                            {isFromManagerSelected && (
                            <div className="table-responsive">
                                <DataTable
                                    className="table-responsive"
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    selectableRows
                                    onSelectedRowsChange={({ selectedRows }) => handleRowSelected(selectedRows)}
                                    clearSelectedRows={!isFocused2}
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                            )}
                              {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                              {isCheckboxSelected && (
                            <div className="row tranfer-row" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px' }}>
                            <div className="col-sm-6 col-md-3" style={{ alignSelf: 'center', marginTop: '10px' }}>
                                <button onClick={TransferEmployee} className="btn btn-orange btn-block w-100">
                                    Transfer Reporting
                                </button>
                            </div>
                            <div className="col-sm-6 col-md-3" style={{ alignSelf: 'center', marginTop: '10px' }}>
                                <button onClick={load} className="btn btn-orange btn-block w-100">
                                    Cancel
                                </button>
                            </div>
                        </div>
                                 )}
                        </div>
                        

                    </div>
                </div>
            
            </IonContent>
        </IonPage>
    )
}
export default ActivityReportingRelation